import { render, staticRenderFns } from "./DownloadFormatChooser.vue?vue&type=template&id=3e8515b6"
import script from "./DownloadFormatChooser.vue?vue&type=script&lang=js"
export * from "./DownloadFormatChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports